import React, { useState, useEffect } from 'react';
import { FaTimes, FaSearch, FaCar, FaSpinner, FaArrowLeft } from 'react-icons/fa';
import { useVehicleBrands } from '../hooks/useVehicleBrands';
import './VehicleBrandsModal.css';

const VehicleBrandsModal = ({ selectedCity, onClose, onVehicleSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const {
    brandsAndModels,
    loading,
    error,
    searchVehicles,
    getVehiclesBySearch
  } = useVehicleBrands({ autoLoad: true, limit: 100 });

  // Busca veículos quando o termo de busca muda
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchVehicles(searchTerm);
    }, 300); // Debounce de 300ms

    return () => clearTimeout(timeoutId);
  }, [searchTerm, searchVehicles]);

  const handleVehicleSelect = (brand, model) => {
    if (onVehicleSelect) {
      onVehicleSelect({
        brand,
        model,
        city: selectedCity
      });
    }
  };

  const filteredBrandsAndModels = getVehiclesBySearch(searchTerm);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content vehicle-brands-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="header-content">
            <button className="back-button" onClick={onClose}>
              <FaArrowLeft />
            </button>
            <div className="city-info">
              <h2>{selectedCity?.fullName || 'Cidade Selecionada'}</h2>
              <button className="change-city-btn" onClick={onClose}>
                Escolher outra cidade
              </button>
            </div>
            <button className="modal-close" onClick={onClose}>
              <FaTimes />
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="search-section">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Buscar veículos"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* Vehicle List */}
        <div className="vehicle-list-container">
          {loading ? (
            <div className="loading-state">
              <FaSpinner className="loading-spinner" />
              <p>Carregando veículos...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <p>Erro: {error}</p>
              <button onClick={() => searchVehicles(searchTerm)} className="retry-button">
                Tentar Novamente
              </button>
            </div>
          ) : filteredBrandsAndModels.length > 0 ? (
            <div className="vehicle-list">
              {filteredBrandsAndModels.map((brand) => (
                <div key={brand.id} className="brand-section">
                  {brand.models.map((model) => (
                    <button
                      key={model.id}
                      className="vehicle-item"
                      onClick={() => handleVehicleSelect(brand, model)}
                    >
                      <div className="vehicle-icon">
                        <FaCar />
                      </div>
                      <div className="vehicle-info">
                        <div className="vehicle-name">
                          {brand.name} {model.name}
                        </div>
                        <div className="vehicle-details">
                          Todos os modelos • {model.yearStart} a {model.yearEnd}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>Nenhum veículo encontrado</p>
              {searchTerm && (
                <p className="search-tip">
                  Tente buscar por uma marca ou modelo diferente
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleBrandsModal;
